import { BaseNodeModel } from "@/models/nodes/BaseNodeModel";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeId } from "@/models/nodes/types";
import type { VisitableNode, NodeVisitor } from "@/models/nodes/visitors/NodeVisitor";
import type { PlainTextNodeProps, PlainTextNodeConstructorProps, SymbolFont } from "@corca/data";

export class PlainTextNodeModel extends BaseNodeModel<PlainTextNodeProps> implements VisitableNode {
  static type = "plainText" as const;

  type = PlainTextNodeModel.type;

  protected fillRequiredProps(props: PlainTextNodeConstructorProps): PlainTextNodeProps {
    this.reportMissingProps(props, ["value"]);
    return { ...props, value: props.value ?? "" };
  }

  static create(
    doc: DocumentModel,
    value: string,
    props: Omit<PlainTextNodeConstructorProps, "value"> = {},
    id?: NodeId,
  ) {
    return new PlainTextNodeModel(doc, id, { ...props, value });
  }

  get isEditable(): boolean {
    return true;
  }

  get value(): string {
    return this.props.value;
  }

  set value(value: string) {
    this.updateProps({ value });
  }

  getFont(): SymbolFont {
    return { fontSize: this.props.fontSize, fontFeature: this.props.fontFeature };
  }

  accept<R>(visitor: NodeVisitor<R>): R {
    return visitor.visitPlainTextNode(this);
  }
}
